// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"230":"9f7efeb2","725":"a8696584"}[chunkId] + ".chunk.js";
};